import { ReactElement } from "react";
import { Link } from "react-router-dom";
import { useSEO } from "@/hooks/useSEO";

const NotFound = (): ReactElement => (
    <>
        {useSEO({ title: "Sidan kunde inte hittas - 404 - HittaPodd.se", noindex: true })}
        <div>
            <h4>Sidan kunde inte hittas</h4>
            <p>
                Prova att gå till <Link to={"/"}>startsidan</Link> eller <Link to={"/kontakt"}>kontakta oss</Link> om du
                tror att något är knas som vi borde ta en kika på.
            </p>
        </div>
    </>
);

export default NotFound;
